import React, { Component } from 'react'
import ModularPage from '../common/ModularPage'
import { gqlConnect } from 'react-connect-graphql-beta'
import { withSplash } from '../hocs/withSplash'
import { withSizes } from '@oos-studio/website-common-components'

class DefaultPage extends Component {
  render() {
    return <ModularPage gql={{ entry: this.props.gql }} />
  }
}

export default gqlConnect('page')(withSplash(withSizes(DefaultPage)))
